import { CpuIcon, MapPinIcon, MonitorPlayIcon, RocketIcon } from 'lucide-react';

export const comparison: Array<[string, string, string]> = [
  ['Preparar clases sobre IA y cultura', 'Buscás horas sin encontrar nivel suficiente', '80+ prompts, flujos de trabajo y casos de uso listos'],
  ['Enseñar comunicación digital avanzada', 'Tenés datos básicos pero no el sistema completo', 'Sistema CULTURA 360°, Reels, analytics y monetización digital'],
  ['Gestionar proyectos en el interior', 'Sin estrategias adaptadas al territorio', 'Guías regionales para NOA, NEA, Cuyo, Patagonia, Pampa y Litoral'],
  ['Responder sobre emprendedurismo cultural', 'Explicás lo básico pero sin modelos concretos', '6 arquetipos del emprendedor, canvas cultural y plan de 90 días'],
  ['Hablar de financiamiento del interior', 'Datos parciales sin estrategia para municipios pequeños', 'Guía completa de negociación con municipios y fondos nacionales'],
  ['Posicionarte como docente de vanguardia', 'Tu material es el mismo que el de todos', 'Enseñás lo que ningún manual de gestión cultural tiene todavía'],
];

export const premiumModules = [
  [
    'Inteligencia Artificial para Gestores Culturales',
    'El Framework GESTIO-IA: más allá del uso básico de ChatGPT. 80+ prompts especializados para diagnóstico, formulación de proyectos, comunicación, presupuestos y evaluación. Flujos completos: de la idea al proyecto en 2 horas, campaña en 3 horas, informe en 1 hora. Biblioteca de prompts de imagen con Midjourney y Canva IA, más un código de buenas prácticas éticas.',
    CpuIcon,
  ],
  [
    'El Sistema CULTURA 360°',
    'Los 5 pilares del contenido digital cultural: Revelar, Educar, Emocionar, Convocar y Celebrar. Los 7 formatos de Reels que mejor funcionan para cultura en Argentina, estrategia de crecimiento orgánico, palancas de engagement, horarios inteligentes, analytics avanzado y monetización digital para instituciones.',
    MonitorPlayIcon,
  ],
  [
    'Manual de Emprendedurismo Cultural Argentino',
    'Los 6 arquetipos del emprendedor cultural 2026: creador-empresario, gestor-emprendedor, formador digital, curador de experiencias, freelance cultural y creator cultural. Del cero al primer ingreso en 90 días, tabla de referencia de precios para servicios culturales y construcción de marca personal.',
    RocketIcon,
  ],
  [
    'Pack Interior Argentino',
    'Guías regionales de NOA, NEA, Cuyo, Patagonia, Pampa y Litoral con proyectos modelo. Financiamiento fuera del AMBA, los 5 argumentos que convencen a los intendentes, patrocinio local, crowdfunding comunitario, inventario patrimonial (Sistema SIPE), turismo cultural y comunicación con recursos mínimos.',
    MapPinIcon,
  ],
] as const;
